<template>
  <div class="PieChartLineValues">
    <div class="p-name">饼图线条配置</div>
    <div class="p-key">
      <span>线条长度</span>
      <el-input size="mini" v-model="pieLength" placeholder="长度"></el-input>
      <span>线条宽度</span>
      <el-input size="mini" v-model="pieWidHei" placeholder="宽度"></el-input>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PieChartLineValues',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  watch: {
    pieLength: {
      deep: true,
      handler: function (newVal) {
        console.log(newVal);
        this.commitCurrentPropertyData(newVal);
      },
    },
    pieWidHei: {
      deep: true,
      handler: function (newVal) {
        console.log(newVal);
        this.commitCurrentPropertyData(newVal);
      },
    },
  },
  data() {
    return {
      pieLength: this.propertyData.pieChartLine.value.length,
      pieWidHei: this.propertyData.pieChartLine.value.WidHei,
    };
  },
  mounted() {
    /* 获取初始值 */
  },
  methods: {
    commitCurrentPropertyData(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.PieChartLineValues {
  margin-top: 10px;
  width: 100%;
  .p-line {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to left,
      rgba(204, 204, 204, 0),
      rgb(143, 143, 143),
      rgba(204, 204, 204, 0)
    );
    margin-bottom: 5px;
  }
  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    display: inline-block;
    padding: 0 15px;
    height: 30px;
    line-height: 30px;
  }
  .p-key {
    margin: 5px 0;
    padding: 0 14px;
    display: flex;
    color: #71717c;
    font-size: 12px;
    height: 30px;
    align-items: center;
    justify-content: space-between;

    span {
      width: 230px;
      box-sizing: border-box;
      padding: 0 8px;
    }

    .el-input {
      width: 100%;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);
      /* width: 82px; */
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
</style>
